// Dependencies
import React from 'react';
import radium from 'radium';
import {connect} from 'react-redux';
import {ThemeContext} from '../../components/theme/Theme.jsx';
import Button from '../../components/button/Button.tsx';

import {toggleShowFreeSeatingPopup} from '../../redux/seatingplanPageReducer';
import {updateVisualBulkTickets} from '../../redux/shoppingCartReducer';
import Title from '../event/categories/Title.jsx';
import PriceLevel from './free-seating/Pricelevel';
import sponsorCodeService from "../../lib/sponsorCodes-service";

class FreeSeatingAmountSelection extends React.Component {
	static contextType = ThemeContext;

	constructor(props) {
		super(props);

		this.state = {
			tktAmountPerPl: props.tktsInCartPerPl,
		};
		this.selectHandler = this.updateTktAmount.bind(this);
	}

	updateTktAmount(event, plUuid) {
		const value = event.target.value;
		if (value) {
			// Parsing is important because select returns string values and those brick the calculations.
			const amount = parseInt(event.target.value, 10);
			const tktAmountPerPl = Object.assign({}, this.state.tktAmountPerPl, {[plUuid]: amount});
			this.setState({tktAmountPerPl});
		}
	}

	render() {
		const style = {
			contentWrapper: {
				margin: 'auto',
				'@media(min-width: 768px)': {
					margin: '4em 0',
				},
				width: '100%',
			},
			buttonContainer: {
				marginTop: '4em',
				width: '100%',
				'@media(min-width: 768px)': {
					width: '230px',
				},
			},
			catAvailability: {
				color: this.context.themeManager.value('category-hint-availability', 'color', 'bg-color-button-hightlight'),
				fontSize: this.context.themeManager.value('category-hint-availability', 'fontSize', 'font-size-100'),
				fontWeight: 600
			},
		};
		const selected = Object.values(this.state.tktAmountPerPl).reduce((acc, sel) => acc + sel, 0);
		const inCart = Object.values(this.props.tktsInCartPerPl).reduce((acc, sel) => acc + sel, 0);
		const nrPending = selected - inCart;
		const spLimit = this.context.themeManager.getIntOrNullFromTheme('seatingplan', 'tkt-selection-limit', null);
		let avail = this.props.freeSeatingAvailable;
		// If there is a limit for sp tickets configured set the rest to reach limit as "addable" for the dropdown.
		if (spLimit) {
			avail = Math.min(avail, (spLimit - this.props.tktsForThisEvent));
		}
		// Subtract those that are selected by dropdown but not yet in cart.
		avail -= nrPending;
		const amountTicketsForShowingHint = parseInt(this.context.themeManager.valueOrDefault('category-hint-availability','amountOfTickets', null, 10))
		const availableTicketsCategory = avail + inCart + nrPending
		return (
			<div style={style.contentWrapper}>
				<Title name={this.props.category.categoryName}>
					{availableTicketsCategory > 0 && availableTicketsCategory <= amountTicketsForShowingHint && (
						<div className="category__hint--availability" style={style.catAvailability}>
							{`Nur noch ${availableTicketsCategory} Ticket(s) verfügbar!`}
						</div>
					)}
				</Title>
				{this.props.priceLevels.length > 0 &&
					<ul>
						{this.props.priceLevels.map((priceLevel) => {
								let selectable = avail + (this.state.tktAmountPerPl[priceLevel.priceLevelUuid] || 0);
								if (priceLevel.maxAllowed && selectable >= priceLevel.maxAllowed) {
									selectable = priceLevel.maxAllowed;
								}
								if (this.props.maxAmountForSponsorPl[priceLevel.priceLevelUuid] &&
									selectable >= this.props.maxAmountForSponsorPl[priceLevel.priceLevelUuid]) {
									selectable = this.props.maxAmountForSponsorPl[priceLevel.priceLevelUuid]
								}
								return ((!priceLevel.hideOnline) &&
									<li key={priceLevel.priceLevelUuid}>
										<PriceLevel
											categoryUuid={this.props.category.categoryUUID}
											pricelevel={priceLevel}
											ticketsAvailable={selectable}
											selectedAmount={this.state.tktAmountPerPl[priceLevel.priceLevelUuid]}
											onChange={this.selectHandler}
										/>
									</li>
								);
							},
						)}
					</ul>
				}
				<Button
					name={'visBulkTktButton'}
					buttonText={inCart === 0 ? 'In den Warenkorb' : 'Warenkorb aktualisieren'}
					onClick={() => this.props.onClick(this.props.freeSeatingIdentifier, this.state.tktAmountPerPl, this.props.priceLevels)}
					btnStyle={'highlight'}
					buttonContainerStyle={style.buttonContainer}
					iconName={'shopping-cart'}
				/>
			</div>
		);
	}
}

// ------------------------------
// Store Connection
// ------------------------------
const mapStateToProps = (state) => {
	const freeSeatingIdentifier = state.seatingplanPageReducer.selectedFreeSeating;
	const freeSeatingData = state.seatState.freeSeatingInfoMap;
	const freeSeatingSponsorReservations = state.sponsorCodes.freeSeatReservations || [];
	const redeemedSponsorCodeUsages = Object.keys(state.sponsorCodes.codeUsagesPlUuidMap)
	const plsForRedeemedCodeUsages = Object.values(state.sponsorCodes.codeUsagesPlUuidMap)
	const amountFreeSeatingSponsorReservations = sponsorCodeService.getFreeSeatingAmountForSponsorReservations(
		freeSeatingSponsorReservations,
		freeSeatingIdentifier,
		redeemedSponsorCodeUsages)
	const isPlForRedeemedCodeAvailable = (pl) => {
		return plsForRedeemedCodeUsages.indexOf(pl.priceLevelUuid) !== -1
	}

	const shoppingCart = state.shoppingCart.elements[state.merchant.merchantId] || {events: []};
	const tktsForThisEvent = !shoppingCart.events || !shoppingCart.events.find(e => e.eventUuid === state.event.selected) ? 0 :
		shoppingCart.events.find(e => e.eventUuid === state.event.selected).displayTickets.reduce((acc, dt) => acc + dt.numberOfSeats, 0);
	const catUuid = freeSeatingData[freeSeatingIdentifier].categoryUuid;
	const tktsInCartPerPl = !shoppingCart.events ? {}
		: shoppingCart.events.flatMap(scEvent => scEvent.displayTickets)
			.filter((tkt) => (
				tkt.seatIdentifier === freeSeatingIdentifier &&
				tkt.categoryUuid === freeSeatingData[freeSeatingIdentifier].categoryUuid))
			.reduce((acc, visBulkTkt) => (Object.assign(acc, {[visBulkTkt.priceLevelUuid]: visBulkTkt.numberOfSeats})), {});
	const category = state.event.elements[state.event.selected].categories.find(cat => cat.categoryUUID === catUuid);

	const sortedReducedPricelevels = Object.assign([], category.reducedPriceLevels).sort((a, b) => {
		if ((a.pos === null) && (b.pos === null)) {
			return 0;
		}
		return a.pos > b.pos ? 1 : -1;
	});
	// remove null, and undefined and filter by code
	const priceLevels = [category.standardPriceLevel, ...sortedReducedPricelevels]
		.filter(pl => (
			pl != null &&
			(!pl.accessCodeNeeded || state.accessCodes.plUuidCodeMap[pl.priceLevelUuid]) &&
			(!pl.forSponsors || isPlForRedeemedCodeAvailable(pl)))
		);

	// calculate max amount for sponsor price levels
	let maxAmountForSponsorPl = {}
	priceLevels.forEach(pl => {
		for (const [key, value] of Object.entries(state.sponsorCodes.codeUsagesPlUuidMap)) {
			if (value === pl.priceLevelUuid) {
				const amountReservedAndAvailable = sponsorCodeService.getFreeSeatingAmountForCodeUsage(freeSeatingSponsorReservations, freeSeatingIdentifier, key)
				maxAmountForSponsorPl[value] = maxAmountForSponsorPl[value] ? maxAmountForSponsorPl[value] + amountReservedAndAvailable : amountReservedAndAvailable;
			}
		}
	})
	// filter price levels if sponsor reservations are only for seats and not for free seating
	const filteredPricelevels = priceLevels.filter(pl => maxAmountForSponsorPl[pl.priceLevelUuid] !== 0)
	return {
		freeSeatingIdentifier,
		freeSeatingState: freeSeatingData,
		freeSeatingAvailable: freeSeatingData[freeSeatingIdentifier].availableTickets - amountFreeSeatingSponsorReservations,
		tktsInCartPerPl,
		tktsForThisEvent,
		category,
		priceLevels: filteredPricelevels,
		maxAmountForSponsorPl
	};
};

const mapDispatchToProps = (dispatch) => ({
	onClick: (freeSeatingIdentifier, numOfTktsPerPriceLvlSc, priceLevels) => {
		/* Backend needs for every pricelevel the amount of tickets, so we create a new object with all pricelevels
		and set the value from numOfTktsPerPriceLvlSc if there is any */
		const amountOfTicketsPerPriceLvl = priceLevels.reduce((acc, pl) => (Object.assign(acc, {
			[pl.priceLevelUuid]:
				numOfTktsPerPriceLvlSc[pl.priceLevelUuid] ? numOfTktsPerPriceLvlSc[pl.priceLevelUuid] : 0
		})), {});
		dispatch(updateVisualBulkTickets(freeSeatingIdentifier, amountOfTicketsPerPriceLvl));
		dispatch(toggleShowFreeSeatingPopup());
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(radium(FreeSeatingAmountSelection));
